// extracted by mini-css-extract-plugin
export var container = "Profile-module--container--jD4t1";
export var containerNarrow = "Profile-module--container-narrow--2GlQZ";
export var containerWide = "Profile-module--container-wide--FyHv1";
export var fontDisplay = "Profile-module--font-display--A+mpX";
export var fontSansSerif = "Profile-module--font-sans-serif--CGXsq";
export var hover = "Profile-module--hover--9TOG0";
export var linkUl = "Profile-module--link-ul--PAoHF";
export var lock = "Profile-module--lock--VbrFq";
export var mainInner = "Profile-module--main-inner--2BSkM";
export var onlyForMedium = "Profile-module--only-for-medium---8OEe";
export var onlyForSmall = "Profile-module--only-for-small--ckuXV";
export var pageTitleWrapper = "Profile-module--page-title-wrapper--JR5u-";
export var profile = "Profile-module--profile--dN6hK";
export var profile__image = "Profile-module--profile__image--wlVBI";
export var profile__text = "Profile-module--profile__text--7F5w1";
export var root = "Profile-module--root--Ia7OB";
export var spFull = "Profile-module--sp-full--jCkoI";
export var textCenter = "Profile-module--text-center--y224Z";
export var textLeft = "Profile-module--text-left--JG6NF";
export var textRight = "Profile-module--text-right--ELS6n";